<template>
    <div>
        <span class="badge bg-success" v-if="params.data.isAssigned">{{ params.value }}</span>
        <span class="badge bg-primary" v-else-if="params.data.rubricVersionId && params.data.learnerBuildingLEA">{{ params.value }}</span>
        <span class="badge bg-danger" v-else>{{ params.value }}</span>
    </div>
</template>

<script lang="js">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
    }
  }
})
</script>